import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeletePaymentGateway from '@/modules/bank/api/hooks/useMutationDeletePaymentGateway'
import { BankQueryKeys } from '@/modules/bank/keys'
import LoadingOverlay from '@/common/components/LoadingOverlay'
import { useState } from 'react'

interface DeletePaymentGatewayProps {
	id: string
}

export default function DeletePaymentGateway({
	id,
}: DeletePaymentGatewayProps) {
	const queryClient = useQueryClient()
	const [isOpen, setIsOpen] = useState(false)
	const { mutate: deletePaymentGateway, isPending: isDeleting } =
		useMutationDeletePaymentGateway({
			onSuccess: () => {
				toast.success('ลบธนาคารออโต้สำเร็จ')
				queryClient.invalidateQueries({
					queryKey: [BankQueryKeys.PaymentGateways],
				})
				queryClient.invalidateQueries({
					queryKey: [BankQueryKeys.ChannelCounts],
				})
				setIsOpen(false)
			},
			onError: (error) => {
				showErrorToast(error)
			},
		})

	const handleDelete = () => {
		deletePaymentGateway({ id })
	}

	return (
		<>
			<LoadingOverlay open={isDeleting} message="กำลังลบ ธนาคารออโต้..." />
			<AlertDialog open={isOpen} onOpenChange={setIsOpen}>
				<AlertDialogTrigger asChild>
					<Button variant="ghost" size="icon" disabled={isDeleting}>
						<Trash2 className="h-4 w-4 text-destructive" />
					</Button>
				</AlertDialogTrigger>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>ยืนยันการลบบัญชีธนาคาร</AlertDialogTitle>
						<AlertDialogDescription>
							คุณต้องการลบบัญชีธนาคารนี้ใช่หรือไม่?
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter className="gap-2">
						<AlertDialogCancel disabled={isDeleting}>ยกเลิก</AlertDialogCancel>
						<AlertDialogAction
							onClick={handleDelete}
							disabled={isDeleting}
							className="bg-destructive hover:bg-destructive/90"
						>
							{isDeleting ? 'กำลังลบ...' : 'ยืนยัน'}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	)
}
